export default "__VITE_ASSET__DMz9vdvk__"